'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { BannerSectionModel } from '../../types'

type Props = { props: BannerSectionModel }

const BannerSection = ({ props }: Props) => {
  const { image, text, testId } = props
  const translate = useTranslate()

  return (
    <section className="secondhand-taxes__banner-section" data-testid={testId}>
      <div className="secondhand-taxes__banner-section-image">
        <Image
          src={image.src}
          srcset={image.srcSet}
          scaling={Image.Scaling.Contain}
          loading="lazy"
        />
      </div>
      <div className="secondhand-taxes__banner-section-inner">
        <p className="secondhand-taxes__banner-section-caption">{translate(text.caption)}</p>
        <h2
          className="secondhand-taxes__banner-section-title"
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: translate(text.title) }}
        />
      </div>
    </section>
  )
}

export default BannerSection
